import axios from 'axios';
import React, { useState } from 'react';
import { Alert, Button, Modal, Spinner } from 'reactstrap';

import { Constants } from '@/constants';

export default function ImageImportModal({ type, open, onClose, onResult }) {
  const [selectedImageUrl, setSelectedImageUrl] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [unableToImport, setUnableToImport] = useState(false);
  return (
    <Modal isOpen={open} onClosed={onClose} toggle={onClose}>
      <div className="modal-header">
        <h5 className="modal-title">Add Image From URL</h5>
      </div>
      <div className="modal-body">
        Paste Image URL
        <input
          className="form-control"
          type="text"
          name="image-url"
          placeholder="https://"
          value={selectedImageUrl}
          onChange={(e) => setSelectedImageUrl(e.target.value)}
        />
        {unableToImport && (
          <Alert color="danger" style={{ marginTop: 10 }}>
            <span>
              Unable to import image from URL. Please try a different one.
            </span>
          </Alert>
        )}
      </div>
      <div className="modal-footer">
        <Button onClick={onClose}>Cancel</Button>
        <Button
          disabled={submitting}
          onClick={() => {
            setSubmitting(true);
            setUnableToImport(false);
            const urlParts = selectedImageUrl.split('?')[0].split('/');
            let fileName = urlParts[urlParts.length - 1];
            if (
              fileName.indexOf('.jpg') === -1 &&
              fileName.indexOf('.jpeg') === -1 &&
              fileName.indexOf('.png') === -1
            ) {
              fileName += '.jpg';
            }
            console.log({
              original_src: selectedImageUrl,
              filename: fileName,
              prefix: type,
            });
            axios
              .post(`${Constants.mediaPath}/import`, null, {
                params: {
                  original_src: selectedImageUrl,
                  filename: fileName,
                  prefix: type, // This is the CDN prefix, e.g. 'products', 'cigars', etc
                },
              })
              .then((response) => {
                setSubmitting(false);
                if (typeof onResult === 'function') {
                  onResult(response.data);
                }
              })
              .catch((err) => {
                console.log(err);
                setSubmitting(false);
                setUnableToImport(true);
              });
          }}
          variant="contained"
          color="primary"
        >
          {submitting && (
            <Spinner
              type="border"
              color="light"
              size="sm"
              style={{ marginRight: 10 }}
            />
          )}
          {submitting ? 'Adding image' : 'Add image'}
        </Button>
      </div>
    </Modal>
  );
}
